import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'BlogArticle2Up',
})(({ brandColors, spacing }) => ({
  spacingContainer: {
    backgroundColor: brandColors.tintsOffWhite60,
  },
  grid: {
    rowGap: spacing(3),
  },
  articleHeading: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',

    '& > a': {
      textDecoration: 'inherit',
    },

    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export default useStyles;
